import type { ResourceDataFileResourceReadApi } from '@ingenico/api-sdk-device-management-private-v2';

export function mapCreateResourceResponse(response: ResourceDataFileResourceReadApi): ResourceDataFileResourceReadApi {
  return response;
}
